<template>
    <div>
        <v-server-table v-if="!savedFilterId || (savedFilterId && savedFilter)" ref="inspectionScoreTable" url="/inspections/list" :columns="columns" :options="options">

            <router-link slot="InspectionId" slot-scope="props" :to="`/inspections/view/${props.row.InspectionId}`" title="View Inspection" class="btn btn-sm btn-light">
                View
            </router-link>

            <template slot="InspectionDate" slot-scope="props">
                {{ props.row.InspectionDate | moment("MM/DD/YYYY") }}
            </template>

            <template slot="status_name" slot-scope="props">
                <label :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</label>
            </template>

            <router-link slot="JobsiteName" slot-scope="props" :to="`/jobsites/view/${props.row.JobsiteId}`" title="View Jobiste">
                {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
            </router-link>

            <template slot="scmm_date" slot-scope="props">
                <span v-if="props.row.scmm_date">{{ props.row.scmm_date | moment("MM/DD/YYYY") }}</span>
                <span v-else>--</span>
            </template>

            <template slot="owner_last_name" slot-scope="props">
                {{ props.row.owner_first_name }} {{ props.row.owner_last_name }}
            </template>

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
            </template>

            <router-link slot="form_name" slot-scope="props" :to="`/inspections/forms/view/${props.row.inspection_form_id}`" title="View Inspection Form">
                {{ props.row.form_name }}
            </router-link>

            <template slot="child_row" slot-scope="props">
                <dl class="dl-horizontal">
                    <dt>Total Elements Compliant</dt>
                    <dd>{{ props.row.TotalCompliant }}</dd>
                    <dt>Total Elements NonCompliant</dt>
                    <dd>{{ (props.row.TotalInspected - props.row.TotalCompliant) }}</dd>
                    <dt>Total Elements Inspected</dt>
                    <dd>{{ props.row.TotalInspected }}</dd>
                </dl>
            </template>
        </v-server-table>
    </div>
</template>

<script>
export default {
    props: ['timeFilter', 'savedFilterId'],

    data: function() {
        return {
            savedFilter: null,
            userTimezone: this.$store.state.user.timezone,
            columns: [
                'InspectionId',
                'InspectionDate',
                'DivisionName',
                'JobsiteName',
                'status_name',
                'Superintendent',
                'NumberOfEmployees',
                'GeneralContractor',
                'Score',
                'scmm_date',
                'owner_last_name',
                'created_at',
                'form_name',
            ],
            options: {
                headings: {
                    InspectionId: 'ID',
                    'InspectionDate': 'Date',
                    'DivisionName': 'Division',
                    'JobsiteName': 'Jobsite',
                    'status_name': 'Status',
                    'NumberOfEmployees': '# of Employees',
                    'GeneralContractor': 'Gen. Contractor',
                    'scmm_date': 'SCMM',
                    'owner_last_name': 'Creator',
                    'created_at': 'Created',
                    'form_name': 'Form',

                },
                templates: {
                    Score: 'inspection-score',
                },
                orderBy: {
                    ascending: false,
                    column: 'inspection.InspectionDate',
                },
                responseAdapter: (response) => {
                    //Emit the count
                    this.$emit('inspectionScoreListCount', this.calcAverageScore(response.data.data));

                    //Send it
                    return response.data;
                },
                requestAdapter: (data) => {
                    if(this.savedFilter)
                    {
                        //Get the config
                        var tableConfig = JSON.parse(this.savedFilter.table_config);

                        data.limit = (tableConfig.limit ? tableConfig.limit : 25);
                        data.query = tableConfig.query;
                        data.orderBy = tableConfig.orderBy;
                        data.ascending = tableConfig.ascending;

                        data.filters = this.extractFilters();
                    }
                    else
                    {
                        //Set the filters
                        data.filters = {
                            'inspection.InspectionDate': this.timeFilter.toLowerCase(),
                        };
                    }

                    //Send it
                    return data;
                },
                uniqueKey: 'InspectionId',
            },
        }
    },

    methods: {
        refresh: function() {
            this.$refs.inspectionScoreTable.refresh();
        },
        extractFilters: function() {
            let filters = {
                'jobsite.DivisionId': [],
                'inspection.InspectionDate': '',
                'inspection.SCMM': '',
                'inspection.JobsiteId': {},
                'inspection.inspection_form_id': null,
            };

            let table_filters = JSON.parse(this.savedFilter.table_filters);

            for (var i = 0; i < table_filters['jobsite.DivisionId'].length; i++) {
                //Add each id
                filters['jobsite.DivisionId'].push(table_filters['jobsite.DivisionId'][i]['id']);
            }

            filters['inspection.SCMM'] = table_filters['inspection.SCMM'];
            filters['inspection.InspectionDate'] = table_filters['inspection.InspectionDate'];
            filters['inspection.inspection_form_id'] = table_filters['inspection.inspection_form_id'];

            var jobsite = table_filters['inspection.JobsiteId'];
            filters['inspection.JobsiteId'] = jobsite.hasOwnProperty('JobsiteId') ? jobsite['JobsiteId'] : null;

            return filters;
        },
        calcAverageScore: function(data) {
            let total = 0;
            let count = 0;
            for (let inspection of data)
            {
                if (inspection.TotalInspected)
                {
                    total += inspection.TotalCompliant / inspection.TotalInspected * 100;
                    count++;
                }
            }
            if (count)
            {
                return (total/count).toFixed(2);
            }
            return '-';
        },
    },

    mounted() {
        if (this.savedFilterId)
        {
            for(let i = 0; i < this.$store.state.user.filters.length; i++)
            {
                if (this.$store.state.user.filters[i].id == this.savedFilterId)
                {
                    this.savedFilter = this.$store.state.user.filters[i];
                    break;
                }
            }
        }
    }
}
</script>
